import { useState, useEffect, Children } from 'react';
import { chipListStyles, chipItemStyles } from './ChipListStyles.js';
import { jsx } from '@emotion/react/jsx-runtime';
import { Chip } from '../Chip/Chip.js';

const findActiveIndex = chips => {
  const activeIndex = chips.findIndex(chip => !!chip.props.isSelected);
  return activeIndex > -1 ? activeIndex : 0;
};
const ChipList = _ref => {
  let {
    children,
    onChange,
    ...rest
  } = _ref;
  const [activeIndex, setActiveIndex] = useState(findActiveIndex(children));
  useEffect(() => {
    const nextActiveIndex = findActiveIndex(children);
    setActiveIndex(nextActiveIndex);
  }, [children]);
  const handleListItemClick = (index, event, originalOnClick) => {
    event.persist();
    if (activeIndex === index) {
      return;
    }
    setActiveIndex(index);
    if (typeof originalOnClick === 'function') {
      originalOnClick(event, index);
    }
    onChange && onChange(index);
  };
  const renderChips = () => {
    return Children.map(children, (chip, index) => {
      const {
        onClick,
        ...chipProps
      } = chip.props;
      return jsx("li", {
        css: chipItemStyles,
        children: jsx(Chip, {
          ...chipProps,
          onClick: event => handleListItemClick(index, event, onClick),
          isSelected: activeIndex === index,
          tabIndex: index
        })
      });
    });
  };
  return jsx("ul", {
    css: chipListStyles,
    ...rest,
    role: "tablist",
    children: renderChips()
  });
};

export { ChipList };
//# sourceMappingURL=ChipList.js.map
